import React from "react";
import { ToastContainer } from "react-toastify";
import 'react-toastify/scss/main.scss';

export default class Toast extends React.PureComponent {
   render() {
      return (
         <ToastContainer
            className={"toast-custom"}
            position="top-center"
            autoClose={2000}
            hideProgressBar
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            draggable
            limit={1}
            icon={false}
            closeButton={false}
         />
      )
   }
}